import { useContext } from 'react'
import { ErrorHandlingContext } from './ErrorHandlingContext'

export const useErrorHandling = () => {
  return useContext(ErrorHandlingContext)
}
